import { render, staticRenderFns } from "./TemplateCategories.vue?vue&type=template&id=e7eacfc8&"
import script from "./TemplateCategories.vue?vue&type=script&lang=js&"
export * from "./TemplateCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports